import { all } from "redux-saga/effects";
import { createSessionSaga } from "./sagas/sessionSaga";
import {
    loadConfigurationSaga,
    addItemSaga,
    previewItemSaga,
    removeItemSaga,
    clearPreviewItemSaga,
} from "./sagas/configurationSaga";
import { getConfigurationImageSaga } from "./sagas/imagesSaga";
import { initGoogleAnalyticsSaga, updateGoogleAnalyticsModelIdSaga } from "./sagas/analyticsSaga";
import { stepFrameSaga, triggerPreferredAngleSaga } from "./sagas/viewSaga";
import { initialiseSagaMiddleware } from "../store";
import { abortConfigurationSaga, callToActionSaga } from "./sagas/externalSaga";

function* rootSaga() {
    yield all([
        createSessionSaga(),
        loadConfigurationSaga(),
        getConfigurationImageSaga(),
        addItemSaga(),
        removeItemSaga(),
        previewItemSaga(),
        clearPreviewItemSaga(),
        initGoogleAnalyticsSaga(),
        updateGoogleAnalyticsModelIdSaga(),
        stepFrameSaga(),
        triggerPreferredAngleSaga(),
        callToActionSaga(),
        abortConfigurationSaga(),
    ]);
}

export function startRootSaga() {
    initialiseSagaMiddleware.run(rootSaga);
}
